import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import {useState, useEffect, useCallback} from "react";
import CallIcon from '@mui/icons-material/Call';
import PlaceIcon from '@mui/icons-material/Place';
import WebTheme from "./Componentes/SubComponentes/WebTheme";
import {List, ListItem, Button, TextField, Alert,Box} from '@mui/material';
import WebMail from "./Componentes/WebMail";
import {CajaTexto, CajaTextoMediano, RotuloWebPequeno} from "./Componentes/SubComponentes/CajasTexto";
import Footer from "./Componentes/SubComponentes/Footer";
import {fetchRequest} from "./Componentes/RequestUtils";

//import Grid from '@mui/material/Grid';

export default function OraxContact({ip,port,protocolo,modo}){

    const opciones = ['Dark','Green']
    const pages =((modo === 'oraxulux')?['Inicio','Documentos','Área privada']:
        [ 'Inicio', 'Sobre nosotros', 'Noticias y Actividades', 'Área privada']);
    const [status, setStatus] = useState('');

    const [estiloPagina,setEstiloPagina]=useState((localStorage.getItem('estilo') === 'Dark')?estiloDark
        :estiloGreen);

    /* Color de los iconos de la caja de nuestros datos */
    const estiloIconos={
        color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,
        fontSize:'xxx-large'
    }

    const altoCajas = '60%'; // Porcentaje de altura de las cajas webmail y nuestros datos

    const opcionesOnClick = useCallback((ev) => {
        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark')?estiloDark:estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo',pulsado);
    },[]);

    function onSendMail(name,surname,email,message)
    {
        console.log("En OraxContac. name: ",name, "surname: ", surname, " email: ",email, " message: ",message);
        const callback = (response) =>{
            if(response) {
                if(response.data.sendWebMail) {
                    alert("Correo enviado con éxito");
                    console.log("Respuesa de sendWebMail",response.data.sendWebMail)
                }
                else {
                    alert("Error, no se ha podido enviar el correo");
                }
            }
            else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        fetchRequest('sendWebMail',
            [{nombre:'name',valor:name},{nombre:'surname',valor:surname},{nombre:'email',valor:email},{nombre:'message',valor:message}],
            'POST',ip,port,protocolo,'json',callback);
    }


    return(
        <Box className='Cont' style={{background:estiloPagina.background}}>
            <Box className='ToolBar'>
                <ToolBar
                    gadgets={[
                        <MenuDesplegable
                            key='1'
                            opciones={opciones}
                            opcionesOnClick={opcionesOnClick}>
                        </MenuDesplegable>]}
                    paginas={pages}
                    estilo ={estiloPagina}
                    modo = {modo}>
                </ToolBar>
            </Box>
            <Box className='Cabecera'>
                <h1 style={{margin:'auto',color:(estiloPagina.background === 'black')?WebTheme.colors.letraDark:WebTheme.colors.letraGreen,fontWeight:200}}>
                    Contacto
                </h1>
            </Box>
            <Box className = 'AreaNegocio' sx={{background:estiloPagina.background, display:'flex'}} >

                {/* Caja para correo web */}
                <Box sx={{ml:'1%',width:'48%',height:altoCajas,border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen}}>
                    <WebMail estiloPagina={estiloPagina} modo={modo} onSendMail={onSendMail}></WebMail>
                    {status === 'success' && <Alert severity="success" sx={{ mt: 2 }}>¡Correo enviado!</Alert>}
                    {status === 'error' && <Alert severity="error" sx={{ mt: 2 }}>Error al enviar.</Alert>}
                </Box>

                {/*Caja de localizacion */}
                <Box sx={{ml:'1%',width:'48%'/*,height:altoCajas*/,border:(estiloPagina.background === 'black')?WebTheme.borderLines.lineaDark:WebTheme.borderLines.lineaGreen,display:'inline'}}>
                    <RotuloWebPequeno estiloPagina={estiloPagina} texto = {'Nuestros datos'}></RotuloWebPequeno>
                    <CajaTexto icon = {<CallIcon sx={estiloIconos}></CallIcon>}
                                      textAlign={'left'} marginLeft={'10%'}
                                      estiloPagina={estiloPagina}
                                      texto = {'+34-93 352 70 01'}
                                      marginTop={'0px'}>
                    </CajaTexto>
                    <CajaTexto icon = {<PlaceIcon sx={estiloIconos}></PlaceIcon>}
                                      textAlign={'left'} marginLeft={'10%'}
                                      estiloPagina={estiloPagina}
                                      texto = {'Passeig Ciutat de Mallorca 1,\n08016 Barcelona'}
                                      marginTop={'0px'}>
                    </CajaTexto>
                    <iframe
                        style={{marginLeft:'5%',marginTop:'2%'}}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d418.78917379695883!2d2.179799169372517!3d41.43264423331757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f28!3m3!1m2!1s0x12a4bd2670c20533%3A0x7176f1bab01219cf!2sPasseig%20de%20la%20Ciutat%20de%20Mallorca%2C%201%2C%20Nou%20Barris%2C%2008016%20Barcelona!5e0!3m2!1ses!2ses!4v1751568090248!5m2!1ses!2ses"
                        width="90%"
                        height="60%"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    >
                    </iframe>
                    {/*Recuadro superpuesto para tapar iglesia pentecostal*/}
                    {/*<label style={{position:'absolute',display:'block',top:'64%',left:'65%',zIndex:'10',width:'10%',height:'5%',background:'white'}}>__</label>*/}
                </Box>
            </Box>{/*Area de negocio*/}
            <Footer estilo={estiloPagina} modo={modo}></Footer>
        </Box>
    )
}